import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import ComponentTitle from '../shared/ComponentTitle';
import Video from '../media/Video';
import { bylineToString, authorsToString } from 'utils/NewsUtils';
import { setMetaTags, DataStoreDispatcher } from 'lib/frankly';
import Timestamp from 'components/Timestamp';
import { buildURLFingerprinting } from '../../../shared/utils/UrlUtils';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';

class Clip extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    autoPlay: PropTypes.bool,
    showDockedVideo: PropTypes.bool,
    dockPosition: PropTypes.oneOf(['top-left', 'top-right', 'bottom-left', 'bottom-right']),
    showTimestamp: PropTypes.bool,
    showAbstract: PropTypes.bool,
    timestampOptions: PropTypes.shape({
      showElapsedTime: PropTypes.bool,
      displayShortDateTime: PropTypes.bool
    }),
    titleType: PropTypes.string
  }

  static contextTypes = {
    flux: PropTypes.object.isRequired,
  }

  componentWillMount() {
    const { flux } = this.context;
    const {
      FRN_rawResponses: [
        {
          data: {
            id,
            bylines,
            headline = '',
            link = '',
            seo: {
              description = '',
              keywords = '',
              robot = '',
              canonicallink,
            } = {},
            abstractimage: {
              filename: newsImage = '',
              lastEditedDate = ''
            } = {}
          } = {}
        } = {}
      ] = []
    } = this.props;

    const authors = authorsToString(_.map(bylines, bylineToString));

    this._articleDataStoreDispatcher = new DataStoreDispatcher('franklyinc.com/article');
    this._articleDataStoreDispatcher.set('authors', authors);
    this._articleDataStoreDispatcher.set('articleId', id);

    flux.getActions('Helmet').update({ title: headline });
    const imageURL = buildURLFingerprinting({url: newsImage, lastEditedDate});

    setMetaTags(this, [{
      name: 'description',
      content: description
    }, {
      name: 'keywords',
      content: keywords
    }, {
      name: 'robots',
      content: robot
    }, {
      rel: 'canonical',
      href: canonicallink || link,
      isLink: true
    }, {
      property: 'og:title',
      content: headline
    }, {
      property: 'og:type',
      content: 'article'
    }, {
      property: 'og:url',
      content: link
    }, {
      property: 'og:description',
      content: description
    }, {
      property: 'og:image',
      content: imageURL
    }, {
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:description',
      content: description
    }, {
      name: 'twitter:title',
      content: headline
    }, {
      name: 'twitter:image',
      content: imageURL
    }]);
  }

  render() {
    const {
      FRN_rawResponses: [
        {
          data: {
            id: clipId = '',
            headline: title = '',
            publishedDate: publishDate = '',
            updatedDate: updatedDate = '',
            abstract = '',
            bylines = [],
            options: {
              date: {
                published: {
                  showonclip: showPublishedDate = true
                } = {},
                updated: {
                  showonclip: showUpdatedDate = true
                } = {}
              } = {}
            } = {}
          } = {}
        } = {}
      ] = [],
      autoPlay,
      showDockedVideo,
      dockPosition,
      showTimestamp,
      showAbstract,
      timestampOptions: {
        showElapsedTime,
        displayShortDateTime
      } = {},
      titleType = TITLE_TYPE.PAGE_TITLE
    } = this.props;

    if (!clipId) {
      return null;
    }

    const authors = authorsToString(_.map(bylines, bylineToString));
    const timeStamp = <Timestamp publishDate={publishDate} authors={authors} showElapsedTime={showElapsedTime} displayShortDateTime={displayShortDateTime}/>;

    return (
      <div className="Clip">
        {title ? <ComponentTitle titleType = {titleType} title={title} /> : null}
        {abstract && showAbstract && <div className="Clip-abstract" dangerouslySetInnerHTML={{ __html: abstract }}></div>}
        {showTimestamp && showPublishedDate ? timeStamp : null}
        {showTimestamp && showUpdatedDate && Date.parse(publishDate) !== Date.parse(updatedDate) ?
          (<div className="Timestamp-updated" >
            <span className="Timestamp Timestamp-prefix" >Updated: </span>
            <Timestamp authors={authors} publishDate={updatedDate} showElapsedTime={showElapsedTime} displayShortDateTime={displayShortDateTime}/>
          </div>) : null}
        <Video clipId={clipId} autoPlay={autoPlay} showDockedVideo={showDockedVideo} dockPosition={dockPosition} />
      </div>
    );
  }
}

export default Clip;



// WEBPACK FOOTER //
// ./app/components/news/Clip.js